import { fieldControlUi } from './fieldControlUi'

/** How a vendor `UInput` reached directly opts out of Nuxt UI's own paint into the Mealz field skin. */
export const fieldControlInput = {
  /** `variant: 'none'` unopposes the skin; `fixed` keeps the control's line height matched to its siblings. */
  props: { fixed: true, size: 'md', variant: 'none' },

  /** Announces required entry without enabling native constraint validation. */
  attributes: (required: boolean): { 'aria-required': 'true' | undefined } => ({
    'aria-required': required ? 'true' : undefined
  }),

  /** The control's `ui`; `extraBase` is appended last so a caller's own spacing wins over the skin. */
  ui: (invalid: boolean, extraBase = '') => ({
    base: [
      fieldControlUi.control.base,
      invalid ? fieldControlUi.control.outlineInvalid : fieldControlUi.control.outline,
      extraBase
    ],
    root: fieldControlUi.control.root
  })
} as const
